import { InputText, InputTextProps } from 'primereact/inputtext';
import React from 'react';
import { COMPONENT_SIZE } from '../../../constants';
// Button removed: clear button functionality disabled for now
import CharacterCounter from '../CharacterCounter/CharacterCounter';

export type AppUnderlineInputProps = Omit<InputTextProps, 'label'> & {
  size?: COMPONENT_SIZE;
  maxLength?: number;
  showCharCounter?: boolean;
  width?: string;
  inline?: boolean;
};

const AppUnderlineInput: React.FC<AppUnderlineInputProps> = ({
  size,
  maxLength,
  showCharCounter,
  inline = false,
  width = 'w-full',
  ...props
}) => {
  const sizeClass = size ? `p-inputtext-${size}` : '';
  const className = `${props.className || ''} ${sizeClass} p-inputtext-underline w-full`.trim();
  const currentLength = typeof props.value === 'string' ? props.value.length : 0;

  const outerClass = inline
    ? `inline-flex items-center gap-1 ${width}`
    : `flex flex-col gap-1 ${width}`;

  if (inline) {
    return (
      <span className={outerClass}>
        <span className="w-full relative inline-flex items-center">
          <InputText {...props} maxLength={maxLength} className={className} />
        </span>
      </span>
    );
  }

  return (
    <div className={outerClass}>
      <div className="w-full relative flex items-center">
        <InputText {...props} maxLength={maxLength} className={className} />
      </div>
      {showCharCounter && maxLength && <CharacterCounter current={currentLength} max={maxLength} />}
    </div>
  );
};

export default AppUnderlineInput;
